import { graphql } from "@songtradr-one/shared-common";
import { staticText } from "../../../statics/static-text";
import { NotificationAction } from "../NotificationActions.Parts";

// TEXT
export const text = staticText.actions.bulkDownload;

// STYLES

// DATA
export const BulkDownloadLink_Query = graphql(`
  query BulkDownloadLink($id: ID!) {
    bulkDownload(id: $id) {
      id
      status
      downloadUrl
    }
  }
`);

// TYPES

// CONSTANTS

// FUNCTIONS
/**
 * Resolves a fresh, short-lived download link for a completed bulk download and
 * starts the download in place. Runs on notification click — no navigation, so
 * the user stays on their current page leaving search params state untouched.
 */
export const bulkDownloadAction: NotificationAction = async ({
  data,
  client,
  addToast,
}) => {
  const id = data.bulkDownloadId;
  if (!id) return;

  const { data: result } = await client.query({
    query: BulkDownloadLink_Query,
    variables: { id },
    fetchPolicy: "no-cache",
  });

  const downloadUrl = result?.bulkDownload?.downloadUrl;

  if (downloadUrl) window.location.href = downloadUrl;
  else addToast({ text: text.expired, variant: "error" });
};

// ASSETS
